import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { kpFetch } from '../../../../restClient'
import { toastr } from 'react-redux-toastr'

class ExternalLink extends Component {
    launchLink = (externalLink, user, groupModel, t) => () => {
        if(externalLink.simpleUrl) {
            return window.open(
                externalLink.simpleUrl,
                '_blank'
            )
        }
        kpFetch('POST', '/pluxeeToken', '', {
            context: {
                module: externalLink.module,
                groupModelId: groupModel.id
            }
        })
            .then(({ ok, json }) => {
                console.log('json', json)
                if (!ok || !json.token) throw new Error('Pluxee token request failed')
                return json.token
            })
            .then((token) => {
                console.log('token', token)
                toastr.success(t('redirect'), t('redirectOKMessage'), {
                    timeOut: 0
                })
                window.open(
                    `https://app.cadeaux.pluxee.fr/${externalLink.redirect}&sso=${token}`,
                    '_blank'
                )
            })
            .catch(error => {
                console.log("error", error)
                toastr.error(t('redirect'), t('redirectKOMessage'), {
                    timeOut: 0
                })
            })
    }

    render() {
        const { externalLink, user, groupModel, t } = this.props

        return (
            <li className="GroupModel-moduleList-li" key={externalLink.link}>
                <a onClick={this.launchLink(externalLink, user, groupModel, t)}>
                    {t(externalLink.link)}
                </a>
            </li>
        )
    }
}

ExternalLink.propTypes = {
    externalLink: PropTypes.object.isRequired
}

export default ExternalLink
